import Vue from 'vue';

export default {
    state:{
      cia:{
        nomcia:'',
        logo:'',
        noticias:false,
        apikey_clima:null,
        apikey_html2pdf:null,
        firebase_realtime:'',
        firebase_storage:'',
        firebase_firestore:'',
        color_texto_menu:'#212529',
        color_texto_header:'#fff',
        color_fondo_menu:'#3587d8',
        color_fondo_header:'#3587d8',
        color_fondo_logo:'#3587d8',
        color_3_grafica:'#2962FF',
        color_3_grafica:'#4fc3f7',
        color_3_grafica:'#fff',
        moneda:'PESOS',
        tipo_cambio:18.50,
        url_api:''
      }
    },
    mutations: {
      setCia(state,cia){
        state.cia=cia;
      },
      setEmpresa(state,idcliente){
        state.cia.url_api=Vue.http.options.url+'/'+idcliente;
        Vue.http.options.root=state.menu.empresa.url_api;
        Vue.http.options.url=state.menu.empresa.url_api;
        localStorage.lmsedk_cliente_api=state.menu.empresa.url_api;
      },
      setUbicacion(state,ubicacion){
        state.cia.ubicacion=ubicacion;
      }
    },
    actions: { 
      Consultar_Cia(context){
        Vue.http.get('cia')
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          if (respuestaJson.length>0) {
            context.commit('setCia',respuestaJson[0]);
            context.dispatch('Actualizar_Empresa');
          }
        })
        .catch(error=>{
          
        });
      }
    },
    getters: {  
      getCia(state){
        return state.cia;
      },
      getUbicacion(state){
        return state.cia.ubicacion;
      }
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/cia.js